import React, {useState} from "react";

import * as S from "../Carousel.styles";
import FeedItemSoMeIcon from "../../FeedItemSoMeIcon";
import MediaType from "../../MediaType";
import FeedModal from "../../FeedModal/FeedModal";
import {IMG_SIZES} from "../../../constants";

export default function CarouselItem({sliderIndex, feed, asset}) {
  const [show, setShow] = useState(false);

  const handleOnClick = () => {
    if (asset?.products[0]?.url) {
      window.open(asset.products[0].url, "_blank", "noreferrer");
    }
  };

  return (
    <>
      <S.CarouselItem
        settings={feed?.feedSettings}
        sliderIndex={sliderIndex}
        clickable={
          feed.feedSettings?.showFeedModal ||
          feed.feedSettings?.linkToProductUrl
        }
        {...(feed.feedSettings?.showFeedModal
          ? {
              onClick: () => setShow(true),
            }
          : feed.feedSettings?.linkToProductUrl
          ? {
              onClick: handleOnClick,
            }
          : null)}
        gap={feed?.feedSettings?.gutter}
        slides={
          feed?.feedSettings?.slidesToShow
            ? feed?.feedSettings?.slidesToShow
            : 3
        }
      >
        {feed.feedSettings?.socialMediaIcon ? (
          <FeedItemSoMeIcon asset={asset} />
        ) : null}

        <MediaType
          asset={asset}
          imgSize={IMG_SIZES.preView}
          objectFit="cover"
          aspectRatio="1/1"
          br={feed?.feedSettings?.borderRadius}
          videoSettings={{
            autoplay: "autoplay",
            muted: true,
            loop: true,
            controls: false,
            playsinline: true,
          }}
        />

        <S.ItemOverlay settings={feed?.feedSettings}></S.ItemOverlay>
      </S.CarouselItem>
      {feed.feedSettings?.showFeedModal ? (
        <FeedModal
          isOpen={show}
          feed={feed}
          asset={asset}
          onClose={() => setShow(false)}
        />
      ) : null}
    </>
  );
}
